<div fxLayout="row" fxLayoutAlign="center center" >
  <div class="container" fxLayout="column"  fxLayoutAlign="center center"  fxLayoutGap="32px">
    <mat-card>
      FORBIDDEN
    </mat-card>    
  </div>
</div>